import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminUserGuard } from '../users/guards/admin-user.guard';
import { AccountComponent } from './account/account.component';

export const ACCOUNT_ROUTES: Routes = [
    {
        path: 'account',
        component: AccountComponent,
        canActivate: [AdminUserGuard]
    }
];

@NgModule({
  imports: [RouterModule.forChild(ACCOUNT_ROUTES)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
